import { render, staticRenderFns } from "./TheDesign.vue?vue&type=template&id=6227ff86"
import script from "./TheDesign.vue?vue&type=script&lang=js"
export * from "./TheDesign.vue?vue&type=script&lang=js"
import style0 from "./TheDesign.vue?vue&type=style&index=0&id=6227ff86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports